import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-rfebm-primary-button',
  templateUrl: 'rfebm-primary-button.component.html',
  styleUrls: ['rfebm-primary-button.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class RfebmPrimaryButtonComponent {

  @Input() isDisabled: boolean = false;
  @Input() size: "medium" | "small" = "medium"

  @Output() onClick: EventEmitter<void> = new EventEmitter<void>();

  constructor() { }

  protected handleClick(): void {
    if (!this.isDisabled) {
      this.onClick.emit();
    }
  }

}
